import { render, staticRenderFns } from "./TransferenciaEmprestimo.vue?vue&type=template&id=2c9930dc&"
import script from "./TransferenciaEmprestimo.vue?vue&type=script&lang=js&"
export * from "./TransferenciaEmprestimo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports